import initMutations from './init'
import commonMutations from './common'
import casesMutations from './cases'
import createCase from './create-case'
import caseCreationOrders from './case-creation-orders'
import updateCaseCreationOrder from './update-case-creation-order'
import caseCreationOrderForm from './case-creation-order-form'
import fetchDPUrl from './fetch-dp-url'

export default {
  ...initMutations,
  ...commonMutations,
  ...casesMutations,
  ...createCase,
  ...caseCreationOrders,
  ...updateCaseCreationOrder,
  ...caseCreationOrderForm,
  ...fetchDPUrl
}
